import { createFileRoute } from '@tanstack/react-router';
import { MyReimbursementsPage } from '@/features/reimbursements/components/MyReimbursementsPage';
import { usePermissions } from '@/common/hooks/usePermissions';
import { Permission } from '@/common/enums/permissions.enum';

export const Route = createFileRoute('/_authenticated/reimbursements/my-requests')({
  component: MyReimbursementsRoute,
});

function MyReimbursementsRoute() {
  const { hasPermission } = usePermissions();
  if (!hasPermission(Permission.REIMBURSEMENTS_VIEW_OWN)) {
    return (
      <div className="flex items-center justify-center h-64">
        <p className="text-muted-foreground">
          Você não tem permissão para acessar esta página.
        </p>
      </div>
    );
  }
  return <MyReimbursementsPage />;
}
